"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateJSONPath = exports.isJSONPath = exports.INVALID_JSON_PATH_ERROR = exports.INVALID_PATH_ERROR = void 0;
var _isValidPath = _interopRequireDefault(require("is-valid-path"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var INVALID_PATH_ERROR = "node-jq: invalid path argument supplied (not a valid path)";
exports.INVALID_PATH_ERROR = INVALID_PATH_ERROR;
var INVALID_JSON_PATH_ERROR = "node-jq: invalid path argument supplied (not a .json file)";
exports.INVALID_JSON_PATH_ERROR = INVALID_JSON_PATH_ERROR;
var isJSONPath = function(path) {
    return /\.json$/.test(path);
};
exports.isJSONPath = isJSONPath;
var validateJSONPath = function(path) {
    if (!(0, _isValidPath).default(path)) {
        throw new Error("".concat(INVALID_PATH_ERROR, ': "').concat(path, '"'));
    }
    if (!isJSONPath(path)) {
        throw new Error("".concat(INVALID_JSON_PATH_ERROR, ': "').concat(path === "" ? "" : path, '"'));
    }
    return true;
};
exports.validateJSONPath = validateJSONPath;
